###
# Параметры:
#   data: [{orders_amount, total_revenue, average_ticket}]
#
# Возможны утечки памяти в didInsertElement
###
App.OrdersDynamicsGraphComponent = Em.Component.extend
  classNames: ['orders-dynamics-graph']
  dateFormat: 'D MMMM YYYY'

  didInsertElement: ->
    @_updateGraph()
    Em.$(window).on('resize', @resizeHandler.bind(@))

  willDestroyElement: ->
    Em.$(window).off('resize', @resizeHandler.bind(@))

  resizeHandler: ->
    Em.run.debounce(@, @_updateGraph, 100)

  onDataChanged: (->
    @_updateGraph()
  ).observes('data')

  normalizedData: (->

    _.chain( @get('data') )
      .map (d) -> [d.orders_count, d.revenue, d.average_check]
      .unzip()
      .map (d) => @_normalizeData(d)
      .value()

  ).property('data')

  _normalizeData: (data) ->
    return unless data?.length > 0
    first = data[0]
    data = data.map (x) -> x - first
    n = Math.max(Math.abs(d3.min(data)), Math.abs(d3.max(data)))
    data.map((x) -> if n != 0 then x / n else x)

  _updateGraph: ->
    return if @get('isDestroyed') or @get('isDestroying')
    return unless @$()?

    data = @get('normalizedData')
    return unless Em.isArray(data)

    # Очищение содержимого фиксит баг, когда ширина @$() не уменьшается при ресайзе окна
    @$().empty()

    # Размеры
    containerWidth =  @$().outerWidth()
    containerHeight =  @$().outerHeight()

    margin =
      top: 20
      right: 10
      bottom: 20
      left: 10

    width = @$().outerWidth() - margin.left - margin.right
    height = @$().outerHeight() - margin.top - margin.bottom

    # Установил границы
    x = d3.scale.linear()
      .domain([0, data[0].length - 1])
      .range([0, width])

    y = d3.scale.linear()
      .domain([-1, 1])
      .range([height, 0])

    # Добавил поверхность для рисования
    root = d3.select(@$().get(0)).style(position: 'relative')

    # Нарисовать SVG
    svg = root.selectAll('svg').data([width])

    svgEnter = svg.enter()
      .append('svg')
        .attr('height', height + margin.top + margin.bottom)
        .style('overflow', 'visible')

    svgEnter.append('g')
      .attr('transform', 'translate(' + 0 + ',' + margin.top + ')')
      .attr('class', 'grid')

    svgEnter.append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
      .attr('class', 'grid-highlight')

    svgEnter.append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
      .attr('class', 'surface')

    svg.attr('width', width + margin.left + margin.right)

    # Нарисовать грид
    grid = svg.select('g.grid')
    gridLine = grid.selectAll('line.grid-line').data(y.ticks(4))
    gridLine.enter()
      .append('line')
        .attr
          class : 'grid-line'
          fill  : 'none'
          'stroke-width' : '1px'
          'shape-rendering' : 'crispEdges'

    gridLine.attr
      x1 : 0
      x2 : width + margin.left + margin.right
      y1 : (d) -> y(d)
      y2 : (d) -> y(d)

    # Нарисовать вертикальный грид для подсветки
    gridHighlight = svg.select('.grid-highlight')
    highlightBar  = gridHighlight.selectAll('.highlight-bar').data(data[0])

    highlightBar.enter().append('line').attr('class': 'highlight-bar')
    highlightBar.exit().remove()

    barLength = Math.abs(y(-1) - y(1))

    highlightBar
      .attr
        x1 : (d, i) -> x(i)
        y1 : y(-1)
        x2 : (d, i) -> x(i)
        y2 : y(1)
        'stroke-width' : '2px'
        'shape-rendering' : 'crispEdges'

      .style
        'opacity': 0
        # 'stroke-dasharray': barLength
        # 'stroke-dashoffset': barLength


    # Нарисовать графики
    classNames = ['orders-count', 'revenue', 'average-check']

    valueline = d3.svg.line()
      # .interpolate('cardinal')
      .x((d, i) -> x(i))
      .y((d) -> y(d))

    surface = svg.select('g.surface')
    initTransition = data.map (d) ->
      d.map (el, i) ->
        el * (if i == 0 or i == d.length - 1 then 1 else Math.random())

    # Линии
    path = surface.selectAll('path')
        .data(data)

    path.enter().append('path')
      .attr
        class: (d, i) -> classNames[i] + ' graph-line'

    path.exit().remove()

    path
      .attr
        d: (d, i) -> valueline(initTransition[i])
      .transition()
      .duration(1000)
      .delay((d, i) -> 100 * i)
      .ease('elastic')
      .attr
        d: (d) -> valueline(d)

    # Кружки
    for dataj, j in data
      circle = surface.selectAll("g.circle.#{classNames[j]}")
        .data(dataj)

      circleEnter = circle.enter().append('g')
        .attr
          class: (d) -> classNames[j] + ' circle'

      circleEnter.append('circle')
          .attr('class', 'dot')
          .attr('r', 4)

      circleEnter.append('circle')
        .attr('class', 'inner-dot')
        .attr('r', 2)
        .attr('fill', 'white')

      circle.exit().remove()

      circle
        .attr('transform', (d, i) -> "translate(#{x(i)} #{y(initTransition[j][i])})")
        .transition()
        .duration(1000)
        .delay((d, i) -> 100 * j)
        .ease('elastic')
        .attr('transform', (d, i) -> "translate(#{x(i)} #{y(d)})")

    # Тултип
    tooltip = root.selectAll('.tooltip').data([0])

    tooltip.enter().append('div')
      .attr 'class': 'tooltip'
      .text ''
      .style
        'z-index': 0
        position: 'absolute'
        left: '-9999px'
        display: 'none'

    tooltip.exit().remove()

    # Области для ховера
    blockWidth = Math.ceil(width / (data[0].length - 1))
    hoverBlocks = surface.selectAll('.hover-block').data(data[0])

    hoverBlocks.enter().append('rect')
      .attr
        class: 'hover-block'

    hoverBlocks.exit().remove()

    hoverBlocks.attr
        x: (d, i) -> x(i) - blockWidth/2
        y: -blockWidth/2
        height: blockWidth + height
        width: blockWidth
        fill: 'rgba(0,0,0,0)'

      .style
        cursor: 'pointer'

      .on('mouseover', (d, i) =>

        @set('hoveredIndex', i)
        tooltip.style(
            display: 'block'
            left: Math.round(x(i)) + margin.left + 'px'
            top: y(1) - 25 + 'px'
          )
          .text(moment(@get('data')[i].date).format(@get('dateFormat')))

        svg.selectAll('.highlight-bar')
          .style('opacity', (d, index) => if index == i then 1 else 0)
        )

      .on 'mouseleave', (d, i) =>
        tooltip.style
          left: '-9999px'
          display: 'none'
        @set('hoveredIndex', undefined)

        svg.selectAll('.highlight-bar')
          .style('opacity', 0)


